import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useHistory, useLocation } from 'react-router-dom';
import DeploymentDashboard from './DeploymentDashboard';
import MachineAssignments from './MachineAssignments';
import PushEnvVars from './PushEnvVars';

const useStyles = makeStyles({
  root: {
    padding: 24,
  },
  tabsContainer: {
    borderBottom: '1px solid #e0e0e0',
    marginBottom: 24,
  },
});

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`deployment-tabpanel-${index}`}
      aria-labelledby={`deployment-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const EcrDeploymentsMain: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  
  // Determine which tab based on URL path
  const getTabFromPath = (pathname: string): number => {
    if (pathname.includes('/assignments')) {
      return 1;
    }
    if (pathname.includes('/env-vars')) {
      return 2;
    }
    return 0;
  };

  const [tabValue, setTabValue] = useState(() => getTabFromPath(location.pathname));

  // Update tab when URL changes (browser back/forward)
  useEffect(() => {
    setTabValue(getTabFromPath(location.pathname));
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    // Update URL when tab changes
    if (newValue === 0) {
      history.push('/admin/ecr_deployments');
    } else if (newValue === 1) {
      history.push('/admin/ecr_deployments/assignments');
    } else if (newValue === 2) {
      history.push('/admin/ecr_deployments/env-vars');
    }
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.tabsContainer}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="deployment tabs">
          <Tab label="Dashboard" id="deployment-tab-0" aria-controls="deployment-tabpanel-0" />
          <Tab label="Machine Assignments" id="deployment-tab-1" aria-controls="deployment-tabpanel-1" />
          <Tab label="Push Env Vars" id="deployment-tab-2" aria-controls="deployment-tabpanel-2" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <DeploymentDashboard />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <MachineAssignments />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <PushEnvVars />
      </TabPanel>
    </Box>
  );
};

export default EcrDeploymentsMain;
